<template>
  <div class="app-main-inner">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('CargoMsg.QuickSearchMsgClassify')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height:300px;">
      <cargo-ag-grid
        no="grid"
        :grid-options="gridOptions"
        :side-bar="sideBarDefs"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <div class="app-main-inner-row row-pagination" style="padding-right:0px;">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
  </div>
</template>

<script>
import { getAllAirServiceProductTemplate } from '@/api/basicData/airServiceProduct'
import { YES_NO_TYPES } from '@/class/cargo/model/parameters/RadioStatusConstants'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'BaseAirServiceProduct',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        isRowSelectable: function(row) {
          return row.data && !row.data.isAdded
        },
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('common.tips.isAdded'),
          field: 'isAdded',
          cellRenderer: params => {
            const iconName = !params.data.isAdded ? 'grid-icon-enabled' : 'grid-icon-disabled'
            const color = params.data.isAdded ? '#67c23a' : '#e6a23c'
            return `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>`
          },
          suppressMenu: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          suppressMenu: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProductID'),
          field: 'productId',
          suppressMenu: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProductName'),
          field: 'productName',
          suppressMenu: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForceRoutingBooking'),
          field: 'forceAirlineBooking',
          suppressMenu: true,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, YES_NO_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirServiceProduct'),
          field: 'isAirlineProduct',
          suppressMenu: true,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, YES_NO_TYPES)
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  created() {
    const self = this
    document.resetBaseAirServiceProduct = function() {
      self.toQuery()
    }
    document.getSelectedBaseAirServiceProductRows = function() {
      return self.gridApi.getSelectedRows()
    }
  },
  beforeDestroy() {
    document.resetBaseAirServiceProduct = null
    document.getSelectedBaseAirServiceProductRows = null
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    toQuery() {
      const self = this
      getAllAirServiceProductTemplate(self.filter).then(res => {
        for (const item of res.data.list) {
          item.isAddedStr = item.isAdded ? this.$t('common.tips.yes') : this.$t('common.tips.no')
        }
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
        self.onGridDateRendered()
      })
    },
    onGridDateRendered() {
      const self = this
      const columnApi = self.gridApi.columnController.columnApi
      const columnIds = []
      self.gridApi.columnController.gridColumns.forEach(p => {
        columnIds.push(p.colId)
      })
      setTimeout(() => {
        columnApi.autoSizeColumns(columnIds)
      })
    }
  }
}
</script>

<style>
</style>
